import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import { DriveItemInfo } from '../../DriveItemList/reducer';
import ContextualMenuItem from '../../../components/ContextualMenu/Item/Container';
import { DownloadGroupStatus } from '../../DownloadManager/reducer';
import DownloadManagerUtils from '../../../utils/downloadManager';
import Utils from '../../../utils';

const mapStateToProps = (state: StoreState) => {
	const {
		driveList,
		galleryInfos: {
			config: galleryConfig,
			config: { clientId }
		},
		downloadManager: {
			downloadGroups: { selected },
		},
		downloadManager,
	} = state;
	const { contextualMenu } = driveList;

	let driveItem: DriveItemInfo | undefined;
	let isTemplate = false;
	let isDownloaded = false;
	const { driveItems } = driveList;
	const privateDirId = Utils.getPrivateDirId(driveList, galleryConfig);
	const privateDir = privateDirId && driveItems[privateDirId];

	if (contextualMenu.isOpened) {
		const { customTemplates: { ids } } = driveList;
		const { driveItemId } = contextualMenu;

		driveItem = driveItems[driveItemId];
		isTemplate = ids.includes(driveItemId);
	}

	const isDownloadAllPendingSelectedItems = !selected.isDownloading && selected.status === DownloadGroupStatus.Started;

	if (driveItem) {
		isDownloaded = DownloadManagerUtils.isItemPersistentlyDownloaded(downloadManager, driveItem.id);
	}

	return {
		driveItem,
		clientId,
		isTemplate,
		isDownloadAllPendingSelectedItems,
		isDownloaded,
		driveItems,
		privateDir,
	};
};

export default connect(mapStateToProps)(ContextualMenuItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ContextualMenu/Item/index.tsx